import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class Conv1BaseValueConverter {
    toView(rowSumData) {
        let price: number = 0;
        if (ObjectHelper.ObjectIs(rowSumData)) {
            for (var propName in rowSumData) {
                if (ObjectHelper.ObjectIs(rowSumData) && ObjectHelper.ObjectIs(rowSumData[propName]) && ObjectHelper.ObjectIs(rowSumData[propName].PriceWithTax)) {
                    price = price + rowSumData[propName].PriceWithTax;
                }
            }
        }
        return price;
    }
}